import { observer } from "mobx-react";
import * as React from "react";
import { AppStore } from "../../stores/AppStore";
import { PerfilStore } from "../../stores/perfil/PerfilStore";
import {
  MDBCol,
  MDBRow,
} from "mdbreact";
import {
  SearchField,
} from "react-bootstrap-table";
const numeral = require("numeral");

interface AssinaturaBloqueadaPageProps {
}

interface AssinaturaBloqueadaPageState {
  isOpen?: boolean;
}

@observer
export class AssinaturaBloqueadaPage extends React.Component<
  AssinaturaBloqueadaPageProps,
  AssinaturaBloqueadaPageState
> {

  constructor(props: any) {
    super(props);
    PerfilStore.load();
  }

  dashboard = () => {
    AppStore.setLocation("/dashboard");
  };

  componentDidMount() {
    AppStore.setTitle("Sua assinatura foi bloqueada");
  }

  createCustomSearchField = (props) => {
    return (
      <SearchField
        className="input-filter"
        defaultValue={props.defaultSearch}
        placeholder="Filtre um CNPJ"
      />
    );
  };

  render() {

    return (
      <div className="dashboard-page">
        <MDBRow>
          <MDBCol md="6">
            <div className="bloco-perfil">
              <div className="dadosAssin">
                <span className="descAssinPerfil">
                  <span className="priceAssinPerfil">
                    <b>R$</b>{" "}
                    {numeral(PerfilStore.obs.valortotal_assinatura).format(
                      "0,0.00",
                    ) || numeral(PerfilStore.obs.totalPlano).format("0,0.00")}
                  </span>{" "}
                  <br />
                  <b>Plano:</b> Mensal <br />
                  {AppStore.obs1.usuario &&
                    AppStore.obs1.usuario.conta.id_assinatura != "" &&
                    (
                      <>
                        <b>Forma de Pagamento:</b>
                        {AppStore.obs1.usuario && PerfilStore.obs.metodo_pagamento.includes("bank_slip")
                          ? " Boleto Bancário"
                          : " Cartão de Crédito"}
                        <br />
                        <b>Próxima Fatura:</b>
                        {" " +
                          PerfilStore.obs.expiraem_assinatura.split("-").reverse()
                            .join("/")}
                      </>
                    )}

                  <br />
                  <b>Faturas pendentes:</b>&nbsp;
                  {PerfilStore.obs.boletos_pendentes.length > 0
                    ? PerfilStore.obs.boletos_pendentes?.map(el => {
                      return (
                        <>
                          <br />
                          <a href={el.url}>Gerar 2º Via {el.vencimento}</a>
                        </>
                      );
                    })
                    : "Nenhuma fatura em aberto"}
                  <br />
                </span>
              </div>
            </div>
          </MDBCol>
        </MDBRow>
      </div>
    );
  }
}

export default AssinaturaBloqueadaPage;
